import { EntityTypeEnum } from "./EntityTypeEnum";
import { cloneObject } from './../Utils/ObjectUtils';


/** get first holder data from the store */
export function getFirstHolderData(state){
    return state.firstHolderData;
}

/** get second holder data from the store */
export function getSecondHolderData(state){
    return state.secondHolderData;
}

/** get holder data from the store */
export function getHolderData(state, entityType){
    if(entityType===EntityTypeEnum.FH){
        return cloneObject(state.firstHolderData);
    }else if(entityType===EntityTypeEnum.SH){
        return cloneObject(state.secondHolderData);
    }
}

/** get widget dto list from the store */
export function getWidgetDTOList(state, entityType){
    if(entityType===EntityTypeEnum.FH){
        return state.firstHolderWidgetList;
    }else if(entityType===EntityTypeEnum.SH){
        return state.secondHolderWidgetList;
    }
}

/** get holder list from the store */
export function getHolderList(state){
  return state.holderList;
}

export function getIsKycProcessCompleted(state){
    return state.isKycProcessCompleted;
  }

  export function getApplicationDTO(state){
    return state.applicationDTO;
  }